import { useEffect, useState } from 'react'
import { api } from '../../api/client'
import EmailReconciliation from './EmailReconciliation'

export default function EmailReconciliationJobs({companyId,saved}:{companyId:string;saved:()=>Promise<void>}) {
  const [open,setOpen]=useState(false)
  const [offset,setOffset]=useState(0)
  const [data,setData]=useState<Awaited<ReturnType<typeof api.emailReconciliationJobs>>|null>(null)
  const [error,setError]=useState('')
  const [refresh,setRefresh]=useState(0)
  useEffect(()=>{
    if(!open)return
    let live=true
    let timer:number|undefined
    const load=async()=>{
      try {
        const result=await api.emailReconciliationJobs(companyId,20,offset)
        if(live){
          if(offset>0 && offset>=result.total){setOffset(Math.max(0,Math.floor((result.total-1)/20)*20));setData(null)}
          else setData(result)
          setError('')
        }
      }catch(e){if(live)setError(e instanceof Error?e.message:'Could not load email acceptance reviews')}
      finally{if(live)timer=window.setTimeout(load,10000)}
    }
    void load()
    return()=>{live=false;window.clearTimeout(timer)}
  },[companyId,offset,open,refresh])
  const page=(next:number)=>{setData(null);setError('');setOffset(next)}
  return <details className="panel" style={{marginBottom:'1.5rem'}} onToggle={event=>{if(event.target===event.currentTarget)setOpen(event.currentTarget.open)}}>
    <summary>Email acceptance review</summary>
    <p className="muted">Review blocked or failed email workflows with unresolved send attempts. Recording verified SES acceptance does not resend an email or confirm delivery.</p>
    {error && <p className="notice crit" role="alert">{error}</p>}
    {!data && open && !error && <p className="muted">Loading email workflows…</p>}
    {data && <>
      {!data.total && <p className="muted">No unresolved email send attempts need review.</p>}
      {data.rows.map(job=><div key={job.id} style={{marginTop:'1rem'}}>
        <p><span className="pill warn">{job.status}</span> {job.action==='follow_up'?'Follow-up email':'Initial email'} · {new Date(job.created_at).toLocaleString()}</p>
        {job.error && <p className="workflow-error">{job.error}</p>}
        <EmailReconciliation companyId={companyId} jobId={job.id} saved={async()=>{setRefresh(value=>value+1);await saved()}} />
      </div>)}
      {data.total>0 && <div className="toolbar" style={{marginTop:'1rem'}}>
        <button className="btn secondary small" disabled={offset===0} onClick={()=>page(Math.max(0,offset-20))}>Previous</button>
        <span className="muted">{offset+1}–{offset+data.rows.length} of {data.total}</span>
        <button className="btn secondary small" disabled={offset+data.rows.length>=data.total} onClick={()=>page(offset+20)}>Next</button>
      </div>}
    </>}
    {error && <button className="btn secondary small" onClick={()=>setRefresh(value=>value+1)}>Retry email reviews</button>}
  </details>
}
